import { getReqAuth } from '../../api';

export const getOmrScanLogs = (params, cb) =>
  getReqAuth('/webapi/institute/omrScanLog/list', {}, `?${new URLSearchParams(params).toString()}`, cb);

export const getOmrScanLogDetail = (id, cb) =>
  getReqAuth('/webapi/institute/omrScanLog/detail/', {}, id, cb);
